var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multipleTree"},[(_vm.treeData.length === 0)?_c('div',[_vm._v("该模块没有东西可瞅")]):_c('a-tree',{ref:"antree",attrs:{"selectable":false,"tree-data":_vm.mydata,"expand-on-click-node":false,"show-line":"","checkable":""},on:{"check":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }